import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Assuming you're using react-router for navigation
import { RiArrowDownSLine } from "react-icons/ri";
import {
  getRequest,
  putRequest,
  putWithFormData,
} from "../../helpers/api.helper";
import { StepPropsType } from "../../types";
import { useLanguage } from "../../context/LanguageContext";
import { totalPropertyValueOptions } from "../../utils/constants";

const Step7 = ({
  bureauId,
  setCurrentStep,
  currentStep,
  steps,
  profileId,
  setCompletedSteps,
}: StepPropsType) => {
  const { t } = useLanguage();
  const [modalData, setModalData] = useState<any>(null);
  const [modalData2, setModalData2] = useState<any>(null);
  const [modalData3, setModalData3] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTerm2, setSearchTerm2] = useState("");
  const [searchTerm3, setSearchTerm3] = useState("");

  const [city, setCity] = useState([]);

  const [formData, setFormData] = useState({
    numberOfFlats: "",
    flatType: "",
    flatValue: "",
    flatLocation: [],
    agricultureLand: "",
    agricultureLandValue: "",
    agricultureLandLocation: [],
    anyMoreProperties: "",
    propertyNames: "",
    totalPropertiesValue: "",
  });
  const Agriculture_Land_Value = [
    { value: 100000, label: "1 Lakh" },
    ...Array.from({ length: 9 }, (_, i) => ({
      value: (i + 2) * 100000,
      label: `${i + 2} Lakhs`,
    })),
    // Adding 20,30,40,50,60,70,80,90 lakhs
    { value: 2000000, label: "20 Lakhs" },
    { value: 3000000, label: "30 Lakhs" },
    { value: 4000000, label: "40 Lakhs" },
    { value: 5000000, label: "50 Lakhs" },
    { value: 6000000, label: "60 Lakhs" },
    { value: 7000000, label: "70 Lakhs" },
    { value: 8000000, label: "80 Lakhs" },
    { value: 9000000, label: "90 Lakhs" },
    // 1 Cr to 5 Cr
    ...Array.from({ length: 5 }, (_, i) => ({
      value: (i + 1) * 10000000,
      label: `${i + 1} Cr above`,
    })),
    // 5 Cr to 500 Cr with 5 Cr increments
    ...Array.from({ length: 99 }, (_, i) => ({
      value: (i + 1) * 50000000 + 50000000, // Starting from 10 Cr (5+5) and incrementing by 5 Cr
      label: `${(i + 1) * 5 + 5} Cr above`,
    })),
  ];
  const dropdownOptions: any = {
    Number_Of_Apartment_Flats: [
      ...Array.from({ length: 10 }, (_, i) => ({
        value: i + 1,
        label: `${i + 1}`,
      })),
      { value: "more", label: "More" },
    ],
    Flat_Type: [
      ...Array.from({ length: 10 }, (_, i) => ({
        value: `${i + 1}bhk`,
        label: `${i + 1} BHK`,
      })),
    ],
    Flat_Value: [
      // 10 lakhs to 1 crore (in 10 lakh increments)
      ...Array.from({ length: 10 }, (_, i) => (i + 1) * 1000000).map(
        (value) => ({
          value: value,
          label: `₹${(value / 100000).toFixed(1)} Lakhs`,
        }),
      ),
      // 1 crore to 10 crores (in 1 crore increments)
      ...Array.from({ length: 10 }, (_, i) => (i + 1) * 10000000).map(
        (value) => ({
          value: value,
          label: `₹${(value / 10000000).toFixed(1)} Crores`,
        }),
      ),
      // 10 crores to 100 crores (in 10 crore increments)
      ...Array.from({ length: 10 }, (_, i) => (i + 1) * 100000000).map(
        (value) => ({
          value: value,
          label: `₹${(value / 10000000).toFixed(1)} Crores`,
        }),
      ),
    ],
    Agriculture_Land: [
      ...Array.from({ length: 100 }, (_, i) => ({
        value: i + 1,
        label: `${i + 1} Acres`,
      })),
    ],
    Agriculture_Land_Value,

    Total_Properties_Value: totalPropertyValueOptions,

    Anymore_Properties: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownOptions2: any = {
    Flat_Location: [
      ...city.map((flat_location: any) => ({
        value: flat_location.city,
        label: flat_location.city,
      })),
    ],
  };
  const dropdownOptions3: any = {
    Agriculture_Land_Location: [
      ...city.map((agriculture_land_location: any) => ({
        value: agriculture_land_location.city,
        label: agriculture_land_location.city,
      })),
    ],
  };

  const [selectedOptions, setSelectedOptions] = useState<any>({});

  const [selectedOptions2, setSelectedOptions2] = useState<any>({
    Flat_Location: [], // Default for languages known (can be multiple)
  });

  const [selectedOptions3, setSelectedOptions3] = useState<any>({
    Agriculture_Land_Location: [], // Default for languages known (can be multiple)
  });

  const openModal = (key: any) => {
    setModalData({ key, options: dropdownOptions[key] });
  };

  const openModal2 = (key: any) => {
    setModalData2({ key, options: dropdownOptions2[key] });
  };

  const openModal3 = (key: any) => {
    setModalData3({ key, options: dropdownOptions3[key] });
  };

  const closeModal = () => {
    setModalData(null);
    setSearchTerm("");
  };
  const closeModal2 = () => {
    setModalData2(null);
    setSearchTerm2("");
  };
  const closeModal3 = () => {
    setModalData3(null);
    setSearchTerm3("");
  };

  useEffect(() => {
    if (!profileId) return;
    if (!city.length) return;

    const fetchStep7Data = async () => {
      try {
        const res = await getRequest(`/bureau/profile/${profileId.martialId}`);
        if (!res?.data) return;
        const data = res.data;

        setSelectedOptions((prev: any) => ({
          ...prev,

          Number_Of_Apartment_Flats: data.numberOfFlats
            ? dropdownOptions.Number_Of_Apartment_Flats.find(
                (opt: any) => opt.value === data.numberOfFlats,
              )
            : prev.Number_Of_Apartment_Flats,

          Flat_Type: data.flatType
            ? dropdownOptions.Flat_Type.find(
                (opt: any) => opt.value === data.flatType,
              )
            : prev.Flat_Type,

          Flat_Value: data.flatValue
            ? {
                value: data.flatValue,
                label: `₹${Number(data.flatValue).toLocaleString("en-IN")}`,
              }
            : prev.Flat_Value,

          Agriculture_Land: data.agricultureLand
            ? {
                value: data.agricultureLand,
                label: `${data.agricultureLand} Acres`,
              }
            : prev.Agriculture_Land,

          Agriculture_Land_Value: data.agricultureLandValue
            ? {
                value: data.agricultureLandValue,
                label: `₹${Number(data.agricultureLandValue).toLocaleString(
                  "en-IN",
                )}`,
              }
            : prev.Agriculture_Land_Value,

          Anymore_Properties: data.anyMoreProperties
            ? dropdownOptions.Anymore_Properties.find(
                (opt: any) => opt.value === data.anyMoreProperties,
              )
            : prev.Anymore_Properties,

          Total_Properties_Value: data.totalPropertiesValue
            ? {
                value: data.totalPropertiesValue,
                label: `₹${Number(data.totalPropertiesValue).toLocaleString(
                  "en-IN",
                )}`,
              }
            : prev.Total_Properties_Value,
        }));

        setSelectedOptions2((prev: any) => ({
          ...prev,
          Flat_Location: Array.isArray(data.flatLocation)
            ? data.flatLocation
            : [],
        }));

        setSelectedOptions3((prev: any) => ({
          ...prev,
          Agriculture_Land_Location: Array.isArray(data.agricultureLandLocation)
            ? data.agricultureLandLocation
            : [],
        }));
        setFormData((prev) => ({
          ...prev,
          numberOfFlats: data.numberOfFlats ?? prev.numberOfFlats,
          flatType: data.flatType ?? prev.flatType,
          flatValue: data.flatValue ?? prev.flatValue,
          agricultureLand: data.agricultureLand ?? prev.agricultureLand,
          agricultureLandValue:
            data.agricultureLandValue ?? prev.agricultureLandValue,
          anyMoreProperties: data.anyMoreProperties ?? prev.anyMoreProperties,
          totalPropertiesValue:
            data.totalPropertiesValue ?? prev.totalPropertiesValue,
        }));
      } catch (err) {
        console.error("Failed to load Step7 data", err);
      }
    };

    if (bureauId) fetchStep7Data();
  }, [profileId, city.length]);

  const handleSelect = (selectedOption: any) => {
    setSelectedOptions({ ...selectedOptions, [modalData.key]: selectedOption });
    closeModal();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    const formattedOptions = {
      numberOfFlats: selectedOptions.Number_Of_Apartment_Flats?.value || "",
      flatType: selectedOptions.Flat_Type?.value || "",
      flatValue: selectedOptions.Flat_Value?.value || "",
      agricultureLand: selectedOptions.Agriculture_Land?.value || "",
      agricultureLandValue:
        selectedOptions.Agriculture_Land_Value?.value || "",
      anyMoreProperties: selectedOptions.Anymore_Properties?.value || "",
      totalPropertiesValue:
        selectedOptions.Total_Properties_Value?.value || "",
    };

    const formDataToSend = {
      // Updated flatLocation to be just an array of strings (city names)
      ...formattedOptions,
      flatLocation: selectedOptions2.Flat_Location,
      agricultureLandLocation: selectedOptions3.Agriculture_Land_Location,

      // Including step flags
      step1: 1,
      step2: 1,
      step3: 1,
      step4: 1,
      step5: 1,
      step6: 1,
      step7: 1,
    };

    try {
      // Send the PUT request to update the data
      const response = await putRequest(
        `/bureau/profile/${profileId?.userId}`,
        formDataToSend,
      );

      if (response.success) {
        setCompletedSteps?.((prev) =>
          prev.includes(currentStep) ? prev : [...prev, currentStep],
        );
        if (currentStep < steps.length) {
          setCurrentStep(currentStep + 1);
        }
      } else {
        alert("Failed to update details.");
      }
    } catch (error) {
      console.error("Error updating details:", error);
    }
  };

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const response = await getRequest("/common/city");
        // @ts-ignore
        setCity(response);
      } catch (error) {
        console.error("Error fetching data:", error);
        alert("Error fetching data. Please try again later.");
      }
    };

    fetchAllData();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the page to the top
  }, []);

  const handleCheckboxChange2 = (event: any, option: any) => {
    const { checked } = event.target;
    const updatedSelectedOptions2 = checked
      ? [...selectedOptions2.Flat_Location, option.value]
      : selectedOptions2.Flat_Location.filter(
          (lang: any) => lang !== option.value,
        );

    setSelectedOptions2({
      ...selectedOptions2,
      Flat_Location: updatedSelectedOptions2,
    });
  };

  const handleCheckboxChange3 = (event: any, option: any) => {
    const { checked } = event.target;
    const updatedSelectedOptions3 = checked
      ? [...selectedOptions3.Agriculture_Land_Location, option.value]
      : selectedOptions3.Agriculture_Land_Location.filter(
          (skill: any) => skill !== option.value,
        );

    setSelectedOptions3({
      ...selectedOptions3,
      Agriculture_Land_Location: updatedSelectedOptions3,
    });
  };

  return (
    <div className="w-full max-w-lg bg-white shadow-lg rounded-lg">
      {/* Form */}
      <div className="space-y-6 px-3 py-4">
        {Object.keys(dropdownOptions).map((key) => (
          <>
            <div className="mb-[-20px]">
              <label className="block text-red-500 font-medium mb-2">
                {t(key.replace(/_/g, " "))}
              </label>
            </div>

            <div
              key={key}
              className="flex flex-col w-full border px-3 border-gray-300 py-3 rounded-lg cursor-pointer hover:shadow-lg transition-all"
              onClick={() => openModal(key)}
            >
              <div className="flex items-center justify-between rounded-lg">
                <span className="text-gray-500 text-md ">
                  {selectedOptions[key]?.label || `Select ${key}`}
                </span>
                <RiArrowDownSLine className="text-3xl text-gray-300 ml-3" />
              </div>
            </div>
          </>
        ))}

        {Object.keys(dropdownOptions2).map((key) => (
          <div key={key} className="mb-[-20px] rounded-lg">
            <label className="block text-red-500 font-medium mb-2 capitalize">
              {t(key.replace(/_/g, " "))}
            </label>

            <div
              className="flex flex-col w-full border px-3 border-gray-300 py-3 rounded-lg cursor-pointer hover:shadow-lg transition-all"
              onClick={() => openModal2(key)}
            >
              <div className="flex items-center justify-between rounded">
                <span className="text-gray-500 text-md ">
                  {selectedOptions2[key]?.length
                    ? dropdownOptions2[key]
                        .filter((opt: any) =>
                          selectedOptions2[key].includes(opt.value),
                        )
                        .map((lang: any) => lang.label)
                        .join(", ")
                    : `Select ${key}`}
                </span>
                <RiArrowDownSLine className="text-3xl text-gray-300 ml-3" />
              </div>
            </div>
          </div>
        ))}

        {Object.keys(dropdownOptions3).map((key) => (
          <div key={key} className="mb-[-20px] rounded-lg">
            <label className="block text-red-500 font-medium mb-2 capitalize">
              {t(key.replace(/_/g, " "))}
            </label>

            <div
              className="flex flex-col w-full border px-3 border-gray-300 py-3 rounded-lg cursor-pointer hover:shadow-lg transition-all"
              onClick={() => openModal3(key)}
            >
              <div className="flex items-center justify-between rounded">
                <span className="text-gray-500 text-md ">
                  {selectedOptions3[key]?.length
                    ? dropdownOptions3[key]
                        .filter((opt: any) =>
                          selectedOptions3[key].includes(opt.value),
                        )
                        .map((skill: any) => skill.label)
                        .join(", ")
                    : `Select ${key}`}
                </span>
                <RiArrowDownSLine className="text-3xl text-gray-300 ml-3" />
              </div>
            </div>
          </div>
        ))}

        {/* Action Buttons */}
        <div className="flex flex-col-reverse sm:flex-row gap-3 pt-6">
          {/* <button
            onClick={() => {
              setCurrentStep(Math.max(1, currentStep - 1));
            }}
            className="flex-1 px-6 py-3.5 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
          >
            Previous
          </button> */}
          <button
            onClick={handleSubmit}
            className="flex-1 px-6 py-3.5 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg font-semibold hover:from-pink-600 hover:to-purple-700 transition-all shadow-lg"
          >
            {currentStep === steps.length ? t("Submit") : t("Next Step")}
          </button>
        </div>
      </div>
      {modalData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {t("Select")} {t(modalData.key)}
            </h2>

            {/* Search Bar */}
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalData.key}`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            {/* Options List */}
            <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
              {modalData.options
                .filter((option: any) =>
                  option.label.toLowerCase().includes(searchTerm.toLowerCase()),
                )
                .map((option: any, index: any) => (
                  <div key={index}>
                    <button
                      className="block w-full text-left px-4 py-2 hover:bg-gray-100 transition"
                      onClick={() => handleSelect(option)}
                    >
                      {option.label}
                    </button>
                    <hr className="border-gray-200 mt-3 mb-3" />
                  </div>
                ))}
            </div>

            {/* Close Button */}
            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal}
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      )}
      {modalData3 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center  items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {t("Select")} {t(modalData3.key)}
            </h2>

            {/* "Select All" Checkbox */}
            {/* <div className="flex items-center space-x-2 mb-4">
                <input
                  id="selectAllCheckbox"
                  type="checkbox"
                  checked={
                    selectedOptions.languagesKnown.length ===
                    dropdownOptions.languagesKnown.length
                  }
                  onChange={handleSelectAllChange}
                  className="form-checkbox h-4 w-4 text-red-600"
                />
                <label className="block text-gray-700">Select All</label>
              </div> */}

            {/* Search Bar */}
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalData3.key}`}
              value={searchTerm3}
              onChange={(e) => setSearchTerm3(e.target.value)}
            />

            {/* Options List */}
            <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
              {modalData3.options
                .filter((option: any) =>
                  option.label
                    .toLowerCase()
                    .includes(searchTerm3.toLowerCase()),
                )
                .map((option: any, index: any) => (
                  <>
                    <div key={index} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        checked={selectedOptions3.Agriculture_Land_Location.includes(
                          option.value,
                        )}
                        onChange={(e) => handleCheckboxChange3(e, option)}
                        className="form-checkbox h-4 w-4 text-red-600"
                      />
                      <label className="block text-gray-700">
                        {option.label}
                      </label>
                    </div>
                    <hr className="border-gray-200 mt-3 mb-3" />
                  </>
                ))}
            </div>

            {/* Close Button */}
            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal3}
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      )}
      {modalData2 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center  items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {t("Select")} {t(modalData2.key)}
            </h2>

            {/* "Select All" Checkbox */}
            {/* <div className="flex items-center space-x-2 mb-4">
                <input
                  id="selectAllCheckbox"
                  type="checkbox"
                  checked={
                    selectedOptions.languagesKnown.length ===
                    dropdownOptions.languagesKnown.length
                  }
                  onChange={handleSelectAllChange}
                  className="form-checkbox h-4 w-4 text-red-600"
                />
                <label className="block text-gray-700">Select All</label>
              </div> */}

            {/* Search Bar */}
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalData2.key}`}
              value={searchTerm2}
              onChange={(e) => setSearchTerm2(e.target.value)}
            />

            {/* Options List */}
            <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
              {modalData2.options
                .filter((option: any) =>
                  option.label
                    .toLowerCase()
                    .includes(searchTerm2.toLowerCase()),
                )
                .map((option: any, index: any) => (
                  <>
                    <div key={index} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        checked={selectedOptions2.Flat_Location.includes(
                          option.value,
                        )}
                        onChange={(e) => handleCheckboxChange2(e, option)}
                        className="form-checkbox h-4 w-4 text-red-600"
                      />
                      <label className="block text-gray-700">
                        {option.label}
                      </label>
                    </div>
                    <hr className="border-gray-200 mt-3 mb-3" />
                  </>
                ))}
            </div>

            {/* Close Button */}
            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal2}
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Step7;
